var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTelegram = function SvgTelegram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1167_29602)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12.3271 8.73334C11.2496 9.18149 9.09627 10.109 5.867 11.516C5.34262 11.7245 5.06792 11.9285 5.04291 12.128C5.00065 12.4651 5.42282 12.5978 5.9977 12.7786C6.07589 12.8032 6.15692 12.8287 6.23998 12.8557C6.80557 13.0395 7.56639 13.2546 7.96191 13.2632C8.32068 13.2709 8.72111 13.123 9.1632 12.8194C12.1804 10.7827 13.7379 9.75327 13.8357 9.73108C13.9047 9.71542 14.0003 9.69574 14.065 9.75331C14.1298 9.81088 14.1234 9.9199 14.1166 9.94915C14.0748 10.1274 12.4176 11.6681 11.56 12.4654C11.2927 12.7139 11.1031 12.8902 11.0643 12.9305C10.9775 13.0207 10.8889 13.106 10.8039 13.188C10.2784 13.6945 9.8844 14.0744 10.8257 14.6947C11.2781 14.9928 11.64 15.2393 12.0011 15.4852C12.3955 15.7538 12.7889 16.0216 13.2978 16.3552C13.4275 16.4402 13.5513 16.5285 13.6719 16.6145C14.1309 16.9417 14.5432 17.2357 15.0526 17.1888C15.3486 17.1615 15.6544 16.8832 15.8096 16.0531C16.1766 14.0913 16.8979 9.84064 17.0647 8.08905C17.0793 7.93559 17.0609 7.73919 17.0461 7.65298C17.0314 7.56676 17.0005 7.44392 16.8885 7.35299C16.7558 7.2453 16.5509 7.22259 16.4592 7.2242C16.0426 7.23154 15.4034 7.45381 12.3271 8.73334Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1167_29602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTelegram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/telegram.067a4615.svg";
export { ForwardRef as ReactComponent };